let bootstrap = require('bootstrap')
$(function () {
    $('[data-input-copy]').each(function () {
        var self = $(this);
        var target = $('#' + self.data("input-copy"));
        self.on('click', function (e) {
            e.preventDefault();
            navigator.clipboard.writeText(target.val()).then(function() {
                // Show the tooltip
                const tooltip = new bootstrap.Tooltip(self[0], {"title":  'Copied to clipboard'});
                tooltip.show()
                // Hide the tooltip after 1 second
                setTimeout(function() {
                    tooltip.dispose();
                }, 1000);
            }, function(err) {
                const tooltip = new bootstrap.Tooltip(self[0], { 'title': 'Copying to clipboard failed (' + err.toString() + ')' });
                tooltip.show()
                // Hide the tooltip after 1 second
                setTimeout(function() {
                    tooltip.dispose();
                }, 1000);
            });
        })
    });
})
